var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobHour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#E5E7DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 9.66797V26.3346",
    stroke: "#8CAEB4",
    strokeWidth: 1.51515,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7874 12.6992H16.1056C14.6412 12.6992 13.4541 13.8863 13.4541 15.3507C13.4541 16.8151 14.6412 18.0022 16.1056 18.0022H19.8935C21.3579 18.0022 22.545 19.1894 22.545 20.6538C22.545 22.1182 21.3579 23.3053 19.8935 23.3053H13.4541",
    stroke: "#8CAEB4",
    strokeWidth: 1.51515,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobHour);
export default __webpack_public_path__ + "static/media/job-hour.142c78fb98e79f6f1bac57edfd98d1b4.svg";
export { ForwardRef as ReactComponent };